import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    accordionResposta: {
        padding: theme.spacing(1),
    },
    containerPaginacao: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    botaoAdicionar: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),

    },
    filterActions: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'flex-end',
    },
    defaultContainer: {
        position: 'relative',
        height: '100%',
        width: '100%',
        overflowY: 'auto',
        padding: theme.spacing(2),
        minHeight: 400
    },
    listContainer: {
        position: 'relative',
        height: '100%',
        width: '100%',
    },
    btnRemover: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        }
    },
    checkbox: {
        padding: 4,
    }
}))